import { render } from "./appointmentListing.vue?vue&type=template&id=0baa067a"
import script from "./appointmentListing.vue?vue&type=script&lang=js"
export * from "./appointmentListing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__